import { type UseQueryResult, useQuery } from 'react-query';
import {
  PerformanceRuleService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PerformanceRuleListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPerformanceRulesList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PerformanceRuleListDto | undefined,
  unknown
> => {
  const {
    createdFromDate: evaluationPeriodFrom,
    createdToDate: evaluationPeriodTo,
    approvalStatusId: approvalStatus,
    ruleStatusId: ruleStatus,
    earnedStatus: earnedStatus,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const performanceRulesList = useQuery(
    [
      'getPerformanceRulesList',
      evaluationPeriodFrom,
      evaluationPeriodTo,
      approvalStatus,
      ruleStatus,
      earnedStatus,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        PerformanceRuleService.getApiAwardApiAppPerformanceRulePerformanceRuleList(
          evaluationPeriodFrom,
          evaluationPeriodTo,
          approvalStatus,
          ruleStatus,
          earnedStatus,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return performanceRulesList;
};

export default useGetPerformanceRulesList;
